import { PanelState } from "@/types/ui";
import { CSSSelector, SelectorCSSName } from "./selectors";
import { BreakdanceDocumentWithExportedTree } from "./document";
import { PropertiesData } from "./tree";
import { ElementPreset } from "./presets";

export enum SnapshotLabelAction {
  CHANGE = "Change",
  DELETE = "Delete",
  COPY = "Copy",
  PASTE = "Paste",
  CLEAR = "Clear",
  DUPLICATE = "Duplicate"
}

export type SnapshotLabelActionAndSubject = {
  action: SnapshotLabelAction;
  subject: string;
};

export type SnapshotOptionalInfo = {
  key?: string | undefined;
  title?: string | undefined;
};

export type SnapshotInfo = SnapshotOptionalInfo & {
  id: number;
};

export type BuilderSnapshotData = SnapshotOptionalInfo & {
  document: BreakdanceDocumentWithExportedTree;
  globalSettings: PropertiesData;
  cssSelectors: CSSSelector[];
  presets: ElementPreset[];
  activeElementId: null | number;
  activeSelectorName: null | SelectorCSSName;
  panelState: PanelState;
};

export type BrowseModeSnapshotData = Omit<
  BuilderSnapshotData,
  "document" | "activeElementId"
>;

export type SnapshotData = BuilderSnapshotData | BrowseModeSnapshotData;

export type TakeBuilderSnapshotArgs = BuilderSnapshotData & {
  title: string;
};

export type TakeBrowseModeSnapshotArgs = BrowseModeSnapshotData & {
  title: string;
};
